export default __webpack_public_path__ + "static/media/neso_loading_icon_sprite.73cb38b2.webp";